export default {
  investmentDeduction: [],
  lossesTransferDeduction: [],
  propertyDeduction: [311, 312],
  socialDeduction: [320, 321, 324, 325, 326, 327, 328],
  // prettier-ignore
  standardDeduction: [
    105, 104, 126, 127, 128, 130, 131, 132, 134,
    135, 136, 137, 138, 139, 142, 143, 144, 145,
    146, 147, 129, 133, 140, 141, 148, 149
  ]
};
